import { Validators } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { FormInputCheckboxComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-checkbox/form-input-checkbox.component';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import {
  FieldConfig,
  NewLineField,
} from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FormSelectComponent } from '../../../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '../../../../../../../shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { generateAddedValueFormName } from '../../../../helpers/form-added-value-name-generator';
import { AddedValueFieldConfig } from '../../../../models/form-added-value-field-config';
import { RmsFormConfig } from '../../../../models/rms-form-config';
import { CutOffEffects } from '../../../../effects/cut-off.effects';
import { DirectProjectProfilesOptionLoader } from '../../../../services/config-loader/loaders/direct-project-profile.service.loader';
import { SingleCatalogsEffects } from '../../../../effects/single-catalogs.effects';
import {
  LocalSpacingsLoaderService,
  SingleApplicationsLoaderService,
  SingleSlumpMultipleProductLoaderService,
  SingleUnloadTypesLoaderService,
} from '../../../../services/config-loader/loaders/single-catalogs.loader.service';
import { SetProjectPropertiesCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-project-properties.command';
import { SetProjectProfileSlumpCommand } from '../../../../services/config-loader/commands/set-project-profile-slump.command.service';
// product form field
import { ProductsOptionsLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/products.loader.service';
import { ProductsOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/products.effects';
import { ProductsDisablerOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/product-enabler.provider';
import { AddedValueOpenPlatformDisabler } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/added-value-enabler.provider';
import { AddedValuesLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/added-value.loader.service';
import {
  LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
  LoadProductAddedValuesNotFormulatingOpenPlatformCommandService,
} from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/load-added-value-not-formulating.command.service';
import { FormInputDateComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/form-input-date.component';
import { FieldDateInputConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/field-date-input.config';
import { defaultDateTranslationNames } from '@ordersnproducts/modules/order-builder/modules/specification/configs/defaultDateTranslationNames';
import { FormInputTimeComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-time/form-input-time.component';
import { TimepickerHourFormat } from '@ordersnproducts/modules/shared/components/cmx-timepicker/cmx-timepicker.component';
import { FieldInputTimeConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-time-config.interface';
import { WeekDay } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/week-day';
import { FormTextAreaComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-textarea/form-textarea.component';
import { LoadSingleCatalogsUnloadType } from '../../../../services/config-loader/commands/single-catalogs-unload-type.command.service';
import { LoadSingleCatalogsApplication } from '../../../../services/config-loader/commands/single-catalogs-application.command.service';
import { LoadSingleCatalogsSpacing } from '../../../../services/config-loader/commands/single-catalogs-spacing.command.service';
import { LoadSingleCatalogsUnloadTime } from '../../../../services/config-loader/commands/single-catalogs-unload-time.command.service';
import { LoadSingleCatalogsLoadSize } from '../../../../services/config-loader/commands/single-catalogs-load-size.command.service';
import { LoadSingleCatalogsSlumpProduct } from '../../../../services/config-loader/commands/single-catalogs-SlumpProduct.command.service';
import { LoadContractOpenPlatformCommandService } from '../../../../services/config-loader/commands/open-platform/load-contract.command.service';
import { RmsChildrenStrategies } from '../../../../models/rms-children-strategies';
import { ContractsOptionLoaderOpenPlatformService } from '../../../../services/config-loader/loaders/open-platform/contract.loader.service';
import { ProductsOptionsLoaderOpenPlatformProvider } from '../../../../providers/open-platform/products-options.provider';
import { ContractOptionsLoaderOpenPlatformProvider } from '../../../../providers/open-platform/contracts.provider';
import { MasterDateBlocker } from '../../../../providers/open-platform/date-blocker.provider';
import { LoadSingleCatalogsProjectProfile } from '../../../../services/config-loader/commands/single-catalogs-project-profile.command.service';
import { FormInputComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input/form-input.component';
import { SetTimepickerDateFromDatepickerCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-timepicker-date-from-datepicker.command';
import { MInDayProvider } from '@ordersnproducts/modules/order-builder/modules/specification/providers/min-day.provider';
import { QuantityOpenPlatformProvider } from '../../../../providers/open-platform/quantity.provider';
import { DateTimeEnablerProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/date-time-enabler.provider';
import { ResetSlotOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/reset-slot.command.service';
import {
  ResetVapsAndContractOPCommandService,
  ResetVapsValueOPCommandService,
} from '../../../../services/config-loader/commands/open-platform/reset-added-value.command.service';
import { SetAddedValueSpecializedCommandService } from '../../../../services/config-loader/commands/open-platform/set-added-value-specialized.command';
import { CheckboxSpecialComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/checkbox-special/checkbox-special.component';
import { SpecialScenariosField } from '../../../../providers/special-scenarios-field.provider';
import { FieldLabelConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { FormInfoMessageComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-info-message/form-info-message.component';
import { QuantityWarningOpenPlatformProvider } from '../../../../providers/open-platform/quantity-warning.provider';
import { TemperatureOptionLoaderService } from '../../../../services/config-loader/loaders/temperature.loader.service';
import { LoadSingleCatalogsTemperature } from '../../../../services/config-loader/commands/single-catalogs-temperature.command.service';
import {
  LoadTemperatureVapsService,
  ResetTemperatureFeatureService,
  ResetTemperatureVapsService,
  TemperatureValidatorRequiredService,
  ValidateCutoffTemperature,
} from '../../../../services/config-loader/commands/temperature-loaders.service';
import { SummerSetLoaderService } from '../../../../services/config-loader/loaders/summerset.loader.service';
import { TemperatureFeatureEnabler } from '../../../../providers/open-platform/temperature.enabler.provider';
import { ValidateTemperatureValueSpecializedCommandService } from '../../../../services/config-loader/commands/open-platform/validate-temperature-vap-specialized.command.service';
import { FormInputCheckboxV2Component } from '../../../../../../../shared/modules/configurable-form/components/form-input-checkbox-v2/form-input-checkbox-v2.component';
import { SpacingDisabledProvider } from '../../../../providers/spacing-disabled.provider';
import { contractVisibleFieldProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/contract-visible-field.provider';
import { ResetUnloadTypeService } from '../../../../services/config-loader/commands/reset-unload-type.service';
import {
  LoadPrimerSlumpService,
  LoadPumpPrimerValuesService,
} from '@ordersnproducts/modules/shared/modules/pump-primer/services/pump-primer.command.service';
import {
  PrimerArrivalBeforeDeliveryLoaderService,
  PrimerSlumpLoaderService,
  PumpPrimerProductLoaderService,
} from '@ordersnproducts/modules/shared/modules/pump-primer/services/pump-primer-mix.loader.service';
import { PumpPrimerProductFieldProvider } from '@ordersnproducts/modules/shared/modules/pump-primer/services/pump-primer-mix-field.provider';
import {
  PUMP_PRIMER_MIX,
  PUMP_PRIMER_QUANTITY,
  PUMP_PRIMER_SLUMP,
  PUMP_PRIMER_ARRIVAL_BEFORE_DELIVERY,
} from 'app/shared/pumping/pumping.constant';
import { UnloadTypeProvider } from '../../../../providers/unload-type.provider';
import {
  UnloadTypeOnChangeService,
  PumpPrimerProductOnChangeService,
} from '../../../../services/config-loader/commands/pump-primer-loader.service';
import { QuantitySingleErrorProvider } from '../../../../providers/open-platform/quantity-single-error.provider';
import { SingleLoadSizesCreateLoaderService } from '../../../../services/config-loader/loaders/single-load-size-create.loader.service';
import { Features } from '@ordersnproducts/features';
import { MinimumQuantityValidationCommandService } from '../../../../services/config-loader/commands/open-platform/minimum-quantity-val.command.service';
import { ContractSecondaryTextProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/contract-secondary-text.provider';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';

export const commandUL = {
  canAddMultipleProducts: true,
  recipe: [
    {
      type: FormInputComponent,
      label: 'id',
      name: 'id',
      placeholder: 'id',
      hidden: true,
      visible: false,
    } as FieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.product_description',
      name: SpecFieldNames.PRODUCT_SELECTION,
      dataTId: SpecFieldTestIds.PRODUCT_DESCRIPTION,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ProductsOptionsLoaderOpenPlatformService,
      optionsProvider: ProductsOptionsLoaderOpenPlatformProvider,
      loading: ProductsDisablerOpenPlatformProvider.IsLoading,
      validation: [Validators.required],
      dynamicEffects: [ProductsOpenPlatformEffects, CutOffEffects],
      placeholder: 'views.specifications.select_product',
      onChange: [
        LoadSingleCatalogsUnloadType,
        LoadSingleCatalogsApplication,
        LoadSingleCatalogsSpacing,
        LoadSingleCatalogsUnloadTime,
        LoadSingleCatalogsSlumpProduct,
        LoadSingleCatalogsLoadSize,
        LoadContractOpenPlatformCommandService,
        LoadSingleCatalogsProjectProfile,
        ResetSlotOpenPlatformCommandService,
        ResetVapsAndContractOPCommandService,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.quantity',
      containerClassNames: ['field-11x field-md-4x retail-control '],
      name: SpecFieldNames.QUANTITY,
      dataTId: SpecFieldTestIds.QUANTITY,
      value: QuantityOpenPlatformProvider.DefaultValue,
      min: 0.01,
      step: 1,
      max: 99999,
      suffix: UNITS.CUBIC_YARD,
      validation: [Validators.required],
      warningMessage: QuantityWarningOpenPlatformProvider.IsLargeOrderMessageQuantity,
      decimals: 1,
      onChange: [ResetSlotOpenPlatformCommandService, MinimumQuantityValidationCommandService],
      errorMessage: QuantitySingleErrorProvider.ErrorMessage,
    } as FieldInputNumberConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.ADJUSTMENT,
      dataTId: SpecFieldTestIds.ADJUSTMENT,
      value: false,
      containerClassNames: ['field-6x field-md-2x retail-control input-number-align'],
      placeholder: 'views.specifications.kicker',
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInputDateComponent,
      label: 'views.specifications.request_date',
      name: SpecFieldNames.DATE,
      dataTId: SpecFieldTestIds.REQUEST_DATE,
      containerClassNames: ['field-12x field-md-6x field-lg-3x rms-mod'],
      placeholder: '',
      forbiddenWeekDays: [WeekDay.SUNDAY],
      onChange: [SetTimepickerDateFromDatepickerCommand],
      translationNames: defaultDateTranslationNames,
      validation: [Validators.required],
      min: MInDayProvider,
      blocked: MasterDateBlocker.MasterDateOnly,
      presetDate: MasterDateBlocker.UniqueDate,
      disabled: DateTimeEnablerProvider.DisableDateFormField,
      hidden: DateTimeEnablerProvider.DisableDateFormField,
      hideOutsideDays: true,
    } as FieldDateInputConfig,
    {
      type: FormInputTimeComponent,
      label: 'views.specifications.request_time',
      name: SpecFieldNames.TIME,
      dataTId: SpecFieldTestIds.REQUEST_TIME,
      containerClassNames: ['field-12x field-md-6x field-lg-3x push-lg-6x rms-mod'],
      placeholder: '',
      hourFormat: TimepickerHourFormat.format12,
      validation: [Validators.required],
      disabled: DateTimeEnablerProvider.DisableTimeFormField,
      hidden: DateTimeEnablerProvider.DisableTimeFormField,
    } as FieldInputTimeConfig,
    {
      type: FormInputComponent,
      label: SpecFieldNames.SCHEDULE_MOMENT,
      name: SpecFieldNames.SCHEDULE_MOMENT,
      dataTId: SpecFieldTestIds.SCHEDULE_MOMENT,
      placeholder: '',
      hidden: false,
      visible: false,
      validation: [Validators.required],
      disabled: DateTimeEnablerProvider.DisableScheduleMomentFormField,
    } as FieldConfig,
    {
      type: FormInputComponent,
      label: SpecFieldNames.WAITING_LIST_MOMENT,
      name: SpecFieldNames.WAITING_LIST_MOMENT,
      dataTId: SpecFieldTestIds.WAITING_LIST_MOMENT,
      placeholder: '',
      hidden: false,
      visible: false,
      disabled: DateTimeEnablerProvider.DisableScheduleMomentFormField,
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.contract',
      name: SpecFieldNames.CONTRACT_SELECT,
      dataTId: SpecFieldTestIds.CONTRACT_SELECT,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ContractsOptionLoaderOpenPlatformService,
      optionsProvider: ContractOptionsLoaderOpenPlatformProvider,
      placeholder: 'views.specifications.select_contract',
      visible: contractVisibleFieldProvider.Visible,
      validation: [Validators.required],
      secondaryTextTransform: ContractSecondaryTextProvider.RejectionCode,
      onChange: [
        ResetVapsValueOPCommandService,
        LoadTemperatureVapsService,
        LoadSingleCatalogsTemperature,
        LoadProductAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        ResetTemperatureFeatureService,
        ResetUnloadTypeService,
        LoadPumpPrimerValuesService,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    // Temperature
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.TEMPERATURE_LABEL,
      dataTId: SpecFieldTestIds.TEMPERATURE_LABEL,
      containerClassNames: ['field-12x field-md-12x'],
      iconColor: 'message-grey',
      text: 'views.specifications.temperature.temp_control_conditions',
      hidden: TemperatureFeatureEnabler.ValidateTemperatureNitroExperience,
      disabled: TemperatureFeatureEnabler.ValidateTemperatureNitroExperience,
    } as FieldLabelConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.temperature.temperature_under',
      name: SpecFieldNames.TEMPERATURE_UNDER,
      dataTId: SpecFieldTestIds.TEMPERATURE_UNDER,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: TemperatureOptionLoaderService,
      hidden: TemperatureFeatureEnabler.ValidateTemperatureNitroExperience,
      disabled: TemperatureFeatureEnabler.DisableIfContractNotSelected,
      placeholder: 'views.specifications.temperature.temperature_under_placeholder',
      onChange: [TemperatureValidatorRequiredService, ResetTemperatureVapsService, ValidateCutoffTemperature],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputCheckboxV2Component,
      name: SpecFieldNames.TEMPERATURE_UNDER_DISABLED,
      dataTId: SpecFieldTestIds.TEMPERATURE_UNDER_DISABLED,
      hidden: true,
      value: true,
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.temperature.summer_set',
      name: SpecFieldNames.SUMMER_SET,
      dataTId: SpecFieldTestIds.SUMMER_SET,
      hidden: TemperatureFeatureEnabler.ValidateTemperatureNitroExperience,
      disabled: TemperatureFeatureEnabler.DisableIfContractNotSelected,
      containerClassNames: ['field-12x field-md-5x retail-control'],
      optionsLoader: SummerSetLoaderService,
      index: -1,
      placeholder: 'views.specifications.temperature.summer_set_placeholder',
      onChange: [
        LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        ValidateTemperatureValueSpecializedCommandService,
      ],
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormInputCheckboxV2Component,
      name: SpecFieldNames.SUMMER_SET_DISABLED,
      dataTId: SpecFieldTestIds.SUMMER_SET_DISABLED,
      hidden: true,
      value: true,
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputCheckboxV2Component,
      name: SpecFieldNames.TEMPERATURE_NONE_CONDITION,
      dataTId: SpecFieldTestIds.TEMPERATURE_NONE_CONDITION,
      containerClassNames: ['field-12x field-md-12x retail-control mb-3'],
      label: 'views.specifications.temperature.declining_temp_control',
      hidden: TemperatureFeatureEnabler.TemperatureConditionValidation,
    } as FieldConfig,
    // ICE
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.ICE_LABEL,
      dataTId: SpecFieldTestIds.ICE_LABEL,
      containerClassNames: ['field-12x field-md-12x'],
      iconColor: 'message-grey',
      text: 'views.specifications.ice.info',
      hidden: TemperatureFeatureEnabler.ValidateTemperatureIceExperience,
    } as FieldLabelConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.ice.quantity',
      name: SpecFieldNames.ICE_QUANTITY,
      dataTId: SpecFieldTestIds.ICE_QUANTITY,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: TemperatureOptionLoaderService,
      hidden: TemperatureFeatureEnabler.ValidateTemperatureIceExperience,
      disabled: TemperatureFeatureEnabler.DisabledByContractVapHaveRefrigerant,
      placeholder: 'views.specifications.ice.quantity_placeholder',
      onChange: [ResetTemperatureVapsService, ValidateCutoffTemperature, ResetSlotOpenPlatformCommandService],
      rehydrate: true,
    } as FieldSelectConfig,
    //
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(0),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FIRST,
      index: 0,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      onChange: [
        LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        SetAddedValueSpecializedCommandService,
      ],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(1),
      dataTId: SpecFieldTestIds.VALUE_ADDED_SECOND,
      index: 1,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [
        LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        SetAddedValueSpecializedCommandService,
      ],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(2),
      dataTId: SpecFieldTestIds.VALUE_ADDED_THIRD,
      index: 2,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [
        LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        SetAddedValueSpecializedCommandService,
      ],
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(3),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FOURTH,
      index: 3,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      limit: true,
      optionsLoader: AddedValuesLoaderOpenPlatformService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
      onChange: [ResetSlotOpenPlatformCommandService, SetAddedValueSpecializedCommandService],
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.project_profiles',
      name: SpecFieldNames.PROJECT_PROFILES,
      dataTId: SpecFieldTestIds.PROJECT_PROFILES,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      placeholder: 'views.specifications.select_projectProfiles',
      optionsLoader: DirectProjectProfilesOptionLoader,
      onChange: [SetProjectPropertiesCommand, SetProjectProfileSlumpCommand],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.application',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: SingleApplicationsLoaderService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_application',
      validation: [Validators.required],
      onChange: [],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.slump',
      name: SpecFieldNames.SLUMP_PRODUCT,
      dataTId: SpecFieldTestIds.SLUMP,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_slump',
      optionsLoader: SingleSlumpMultipleProductLoaderService,
      validation: [Validators.required],
      dynamicEffects: [SingleCatalogsEffects],
      onChange: [],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.load_size',
      name: SpecFieldNames.LOAD_SIZE,
      dataTId: SpecFieldTestIds.LOAD_SIZE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_load_size',
      optionsLoader: SingleLoadSizesCreateLoaderService,
      validation: [Validators.required],
      onChange: [ResetSlotOpenPlatformCommandService],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.spacing',
      name: SpecFieldNames.SPACING,
      dataTId: SpecFieldTestIds.SPACING,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_spacing',
      optionsLoader: LocalSpacingsLoaderService,
      validation: [Validators.required],
      onChange: [ResetSlotOpenPlatformCommandService],
      disabled: SpacingDisabledProvider.Disabled,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unload_type',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.unload_type',
      optionsLoader: SingleUnloadTypesLoaderService,
      validation: [Validators.required],
      disabled: UnloadTypeProvider.Disabled,
      onChange: [UnloadTypeOnChangeService, ResetSlotOpenPlatformCommandService],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.pump_primer_mix',
      name: PUMP_PRIMER_MIX,
      dataTId: SpecFieldTestIds.PUMP_PRIMER_PRODUCT,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.pump_primer_mix',
      optionsLoader: PumpPrimerProductLoaderService,
      validation: [],
      hidden: PumpPrimerProductFieldProvider.ValidateUnloadTypeField,
      hasFeatureEnabled: Features.PUMP_PRIMER,
      onChange: [LoadPrimerSlumpService, PumpPrimerProductOnChangeService, ResetSlotOpenPlatformCommandService],
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.primer_quantity',
      containerClassNames: ['field-12x field-md-3x retail-control'],
      name: PUMP_PRIMER_QUANTITY,
      dataTId: SpecFieldTestIds.PUMP_PRIMER_QUANTITY,
      min: PumpPrimerProductFieldProvider.MinPumpPrimerQuantity,
      step: 1,
      max: PumpPrimerProductFieldProvider.MaxPumpPrimerQuantity,
      suffix: UNITS.CUBIC_YARD,
      validation: [],
      decimals: 1,
      hidden: PumpPrimerProductFieldProvider.ValidatePumpPrimerProductField,
      hasFeatureEnabled: Features.PUMP_PRIMER,
      onChange: [ResetSlotOpenPlatformCommandService],
    } as FieldInputNumberConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.primer_slump',
      name: PUMP_PRIMER_SLUMP,
      dataTId: SpecFieldTestIds.PUMP_PRIMER_SLUMP,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: PrimerSlumpLoaderService,
      placeholder: 'views.specifications.select_slump',
      validation: [],
      hidden: PumpPrimerProductFieldProvider.ValidatePumpPrimerProductField,
      hasFeatureEnabled: Features.PUMP_PRIMER,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.primer_arrival_before_delivery',
      name: PUMP_PRIMER_ARRIVAL_BEFORE_DELIVERY,
      dataTId: SpecFieldTestIds.PUMP_PRIMER_ARRIVAL_BEFORE_DELIVERY,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: PrimerArrivalBeforeDeliveryLoaderService,
      validation: [],
      hidden: PumpPrimerProductFieldProvider.ValidatePumpPrimerProductField,
      onChange: [ResetSlotOpenPlatformCommandService],
      hasFeatureEnabled: Features.PUMP_PRIMER,
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormTextAreaComponent,
      label: 'views.specifications.additional_info',
      name: SpecFieldNames.ADDITIONAL_INFO,
      dataTId: SpecFieldTestIds.ADDITIONAL_INFO,
      containerClassNames: ['field-12x field-md-12x retail-control'],
      placeholder: 'views.specifications.enter_comment',
      maxlength: '63',
      validation: [],
      hidden: SpecialScenariosField.Visible,
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.SPECIAL_INSTRUCTION_INFORMATIVE,
      dataTId: SpecFieldTestIds.SPECIAL_INSTRUCTION_INFORMATIVE,
      containerClassNames: ['field-12x field-md-8x'],
      text: 'views.specifications.extra_options',
      hidden: SpecialScenariosField.Hidden,
    } as FieldLabelConfig,
    {
      type: CheckboxSpecialComponent,
      name: SpecFieldNames.COLOR_INFO,
      dataTId: SpecFieldTestIds.COLOR_INFO,
      containerClassNames: ['field-12x field-md-12x retail-control'],
      label: 'views.specifications.color',
      maxlength: '20',
      visible: SpecialScenariosField.Visible,
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: CheckboxSpecialComponent,
      name: SpecFieldNames.ADDITIONAL_INFO,
      dataTId: SpecFieldTestIds.ADDITIONAL_INFO,
      containerClassNames: ['field-12x field-md-12x retail-control'],
      label: 'views.specifications.special_instr',
      maxlength: '63',
      visible: SpecialScenariosField.Visible,
      validation: [],
    } as FieldConfig,
  ],
  chidlrenStrategies: [RmsChildrenStrategies.MasterContract, RmsChildrenStrategies.MasterDate],
} as RmsFormConfig;
